
import { gql } from '@apollo/client';

export const GET_BIRTHDAY_PEOPLE = gql`
query Birthdays {
  birthdays {
    photoUrl
    identifier
    name
    id
    dob
    preferredName
    scriptName
  }
}`;
